import { createFileRoute } from '@tanstack/react-router';

import { MobilityPage } from '@/module/Author/Mobility/MobilityPage';

export const Route = createFileRoute('/_auth/author/_author/mobility/_mobility/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <MobilityPage />;
}
